import { FlexContainer, CustomLabel } from '@mindmemobile/mm-shared-global';
import React, { FC } from 'react';
import TickIcon from '../../../../../../../images/common/tick-green.svg';
import CrossIcon from '../../../../../../../images/products/cross-red.svg';

type IProps = {
    tax: boolean;
    surcharge: boolean;
    discount: boolean;
    reviews: boolean;
    returnDays?: number;
};

const ItemAlowSection: FC<IProps> = ({ tax, surcharge, discount, reviews, returnDays }) => {
    return (
        <>
            <CustomLabel fontSize="20px" fontWeight="600" margin="20px 0px 30px">
                Allow
            </CustomLabel>

            <FlexContainer spacing={25} fxWrap="wrap" padding="0px 0px 10px">
                <div>
                    <img src={tax ? TickIcon : CrossIcon} className="yes-no-icon" />
                    Tax
                </div>
                <div>
                    <img src={surcharge ? TickIcon : CrossIcon} className="yes-no-icon" /> Surcharge
                </div>
                <div>
                    <img src={discount ? TickIcon : CrossIcon} className="yes-no-icon" /> Discount
                </div>
                <div>
                    <img src={reviews ? TickIcon : CrossIcon} className="yes-no-icon" /> Reviews
                </div>
                {returnDays != undefined && returnDays > 0 && (
                    <div>
                        <img src={returnDays ? TickIcon : CrossIcon} className="yes-no-icon" /> {returnDays} Days
                        Returns
                    </div>
                )}
            </FlexContainer>
        </>
    );
};
export default ItemAlowSection;
